import { callAgroApi } from '@services/agroapi';
import { GeoJSON, IPolygon, SimplePolygonType } from './GeoJSON';
import { Instance, SnapshotIn } from 'mobx-state-tree';
import { withDateProcessors } from './DateTimeUtility';
import { FieldResponse } from '@services/responseTypes';
export interface IDailyForecast {
  timestamp: number;
  accuIconNb: number;
  canonical_name: string;
  short_phrase: string;
  long_phrase: string;
  temp_min: number;
  temp_max: number;
  temp_unit: string;
  srad_value: number;
  srad_unit: string;
  wind_speed: number;
  wind_speed_unit: string;
  wind_gust: number;
  wind_gust_unit: string;
  rain_prob: number;
  rain_value: number;
  rain_unit: string;
  relative_humidity: number;
  relative_humidity_unit: string;
  precipitation_intensity: string | null;
  precipitation_number_of_hours: number;
  wind_direction: number;
}
interface IPrecipitationSummary {
  Precipitation: number;
  Precipitation_unit: string;
  PastHour: number;
  PastHour_unit: string;
  Past3Hours: number;
  Past3Hours_unit: string;
  Past6Hours: number;
  Past6Hours_unit: string;
  Past9Hours: number;
  Past9Hours_unit: string;
  Past12Hours: number;
  Past12Hours_unit: string;
  Past18Hours: number;
  Past18Hours_unit: string;
  Past24Hours: number;
  Past24Hours_unit: string;
}
export interface ICurrentForecast {
  timestamp: number;
  accuIconNb: number;
  canonical_name: string;
  weather_text: string;
  temperature: number;
  temperature_unit: string;
  temperature_real_feel: number;
  temperature_real_feel_unit: string;
  relative_humidity: number | null;
  wind_speed: number;
  wind_speed_unit: string;
  wind_gust: number;
  wind_gust_unit: string;
  wind_direction: number;
  precipitation_summary: IPrecipitationSummary;
}
export const Field = withDateProcessors(GeoJSON.named('Field').views(self => ({
  get production() {
    return self.properties.get('stats')?.get('production');
  },
  get farm() {
    return self.properties.get('farm').toJSON();
  }
})).actions(self => ({
  update(field: {
    name: string;
    location?: SimplePolygonType | null;
    pending?: boolean;
  }) {
    return callAgroApi<FieldResponse>(`/fields/${self.id}`, 'PATCH', {
      name: field.name,
      location: field.location,
      pending: field.pending || false
    }).then(({
      data
    }) => data);
  },
  archive() {
    return callAgroApi(`/fields/${self.id}/archive`, 'POST');
  },
  delete() {
    return callAgroApi(`/fields/${self.id}`, 'DELETE');
  },
  getForecast() {
    return callAgroApi<IDailyForecast[]>(`/fields/${self.id}/forecast/5`, 'GET').then(response => response.data);
  }
})));
export type IField = Instance<typeof Field>;
export type IFieldSnapshotIn = SnapshotIn<typeof Field>;